import { useState, useCallback } from 'react'
import { message as $message } from 'antd'

import { queryDrpAddPriceSwitch } from '@/services/config'

export default () => {
    const [checked, setChecked] = useState(false)
    const [loading, setLoading] = useState(false)

    const getConfig = useCallback(async () => {
        setLoading(true)
        try {
            setChecked(true)
            const { data, message, success } = await queryDrpAddPriceSwitch()
            if (success) {
                setChecked(!!data)
            } else {
                $message.error(message)
            }
        } catch (error) {
            console.error(error)
        }
        setLoading(false)
    }, [])

    return { checked, getConfig, setChecked, loading }
}
